import React from 'react';
import PropTypes from 'prop-types';

// economicDevelopmentContacts use the name field,
// contact contacts use the contactName field.
// We should normalize this...
export const getName = contact => contact.name || contact.contactName;
export const isValidContact = contact => contact && (getName(contact) || contact.contactName2);

const PropertyDetailsContact = ({ contact, className }) => {
  if (!isValidContact(contact)) return null;
  const webAddr = (contact.webAddr || '');

  // eslint-disable-next-line no-confusing-arrow
  const ensureProtocol = url => url.includes('//') ? url : `http://${url}`;
  const removeProtocol = url => url.replace(/^https?:\/\//i, '');

  return (
    <div className={className}>
      { getName(contact) && <div>{getName(contact)}</div> }
      { contact.title && <div>{contact.title}</div> }
      { contact.contactName2 && <div>{contact.contactName2}</div> }
      { contact.organization && <div>{contact.organization}</div> }
      { contact.street && <div>{contact.street}</div> }
      { contact.address1 && <div>{contact.address1}</div> }
      { contact.address2 && <div>{contact.address2}</div> }
      { contact.city && <div>{contact.city}, {contact.state} {contact.zip}</div> }
      { contact.phone && <div>{contact.phone}</div> }
      {
        webAddr &&
        webAddr !== 0 &&
        webAddr !== '0' &&
        <div>
          <a href={ensureProtocol(webAddr)} target="_blank" rel="noopener noreferrer">
            {removeProtocol(webAddr)}
          </a>
        </div>
      }
      { contact.email && <div><a style={{ color: '#9f0000' }} href={`mailto:${contact.email}`}>{contact.email}</a></div> }
      <br />
      <br />
    </div>
  );
};

PropertyDetailsContact.propTypes = {
  contact: PropTypes.object,
  className: PropTypes.string,
};

export default PropertyDetailsContact;



// WEBPACK FOOTER //
// ./src/components/PropertyDetail/PropertyDetailContact/PropertyDetailContact.js